export const paymentRoutes = {
  list: '/admin/payments',
};

export const originalFilterQuery = "credit.activities.action:CREDIT AND credit.balance:>=0"


